import { get as _get } from 'lodash'
import React from 'react'
import { FormFeedback } from './formGenerator'
import { AxiosResponse } from "axios";
import { showError, showSuccess } from "./sweetAlertHelper";

export const extractError = (data: any, methodName: string): {message: string, code: string} => {
    return _get(data, `data.${methodName}.error`, { message: 'Unknown state', code: 'Warning' })
}

/*export const handleResponseWithFeedback = (
    response: any,
    successMessage: string,
    methodName: string,
    setFeedback: React.Dispatch<React.SetStateAction<FormFeedback>>
): void => {
    const error = extractError(response, methodName)
    if (error) {
        return setFeedback({
            type: 'error',
            message: `${_get(error, 'message', 'unknown')} (Error ${_get(error, 'code', 'XXX')})`,
        })
    }
    return setFeedback({ type: 'success', message: successMessage, timeout: 2500 })
}*/

export const handleResponseWithSwal = (
    methodName: string,
    onSuccess?: (response: any) => Promise<any>,
    onError?: (error: any) => Promise<any>) => (response: any): Promise<any> => {
    const error = extractError(response, methodName)
    if (error) {
        return onError ? onError(error) : showError(error.message, error.code)
    }
    return onSuccess ? onSuccess(response) : showSuccess('Everything was fine', 'Success')
}


export const getFilenameByResponse = (response: AxiosResponse<any>): string | null => {
    let filename = null
    const disposition = response.headers['content-disposition']
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
        }
    }
    return filename
}

export const downloadFile = (response: AxiosResponse) => {
    const blob = new Blob([response.data])
    const filename = getFilenameByResponse(response)
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename || 'test')
        return
    }
    const data = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = data
    link.download = filename || 'test'
    link.click()
    setTimeout(() => {
        window.URL.revokeObjectURL(data)
    }, 100)
}
